import React from "react";

function ToggleButton({ isShown, handleHideShow, id = "" }) {
  return (
    <div className="toggler-checkbox">
      <input type="checkbox" id={"cbx_" + id} onChange={handleHideShow} checked={isShown} />
      <label htmlFor={"cbx_" + id} className="toggle">
        <span></span>
      </label>
    </div>
  );
}

export default ToggleButton;
